import React, { Component } from 'react';
import GoogleButton from 'react-google-button';
import {browserHistory} from 'react-router';
import firebase from '../firebase.js';
import logo from '../../../public/icon.png';

export default class Login extends Component {

    constructor(props){
        super(props);
        this.state = {
            loaded: false,
            loggedIn: false,           
            error: '',
            errorMsg: '',
        };        
    }

    componentDidMount = async() => {
        console.log("login component ");        
    }

    componentWillMount () {
        console.log("component will mount");
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
              console.log('user logged',user);
              global.uid = user.uid;
              this.setState({loggedIn: true});
              browserHistory.push("/tasks");
            }
        });
    }
        
    handleGoogleLogin()  {
        const users_col = firebase.firestore().collection('users');
        var provider = new firebase.auth.GoogleAuthProvider();
        provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
        firebase.auth().signInWithPopup(provider).then(async(result) => {
            const user = await users_col.doc(result.user.uid).get();
            console.log("existing user is",user)
            if(!user) {
                await users_col.add({"uid": user.uid,"email": user.email, "name": user.displayName});
            }
            global.uid = user.uid;
            this.setState({loggedIn: true,showLoader: false});
            browserHistory.push("/tasks");
          }).catch(function(error) {
            console.log("Google Login Error ",error);
            var errorCode = error.code;
            var errorMessage = error.message;
            var email = error.email;
            var credential = error.credential;            
          });
    }

    render() {
        const {
            loggedIn,
            error,
            errorMsg,
            loaded,
        } = this.state;
        //if (!loaded) return null;        
        return (
            <div>
                <div style={{display: 'flex', justifyContent:'center'}}>
                    <img src={logo} style={{width: '50', height:'30'}}/>
                </div>                
                <div style={{display: 'flex', height: '80vh', justifyContent:'center', alignItems:'center'}}>
                    <GoogleButton onClick={() => { this.handleGoogleLogin() }}
                />                
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Login/index.js